import Text from '@deprecated-ui/common/Text';
import Icon from '@ant-design/icons';
import { InfoButton } from 'global/Securities/components/Form/TransactionForm/OrderTypeFormItem/styled';
import InfoSvg from 'global/Securities/components/Icons/InfoSvg';
import { formatPrice } from 'features/securities/withdrawal/utils';
import { Flex } from 'features/securities/styled';
import { Field, FieldSet } from '../../../styled';
import Accordion from '../../Accordion';
import { BondInfoType } from '../../../constants';
import { useBondInfoModal } from '../../../stores/useBondInfoModal';

interface Props {
  finalAmount: number;
  tradeAmount: number;
  sellerAccruedInterest: number;
  stampDuty: number;
}

export default function OrderContentBuy({
  finalAmount = 0,
  tradeAmount = 0,
  sellerAccruedInterest = 0,
  stampDuty = 0,
}: Props) {
  const openInfoModal = useBondInfoModal((s) => s.openInfoModal);

  return (
    <Accordion
      title={
        <FieldSet>
          <Field isAccordion>
            <div>Total Pembayaran</div>
            <Text family="bold">Rp{formatPrice(finalAmount.toString())}</Text>
          </Field>
        </FieldSet>
      }
      isPlain
      isTight
    >
      <FieldSet>
        <Field>
          <div>Nilai Pembelian</div>
          <div>Rp{formatPrice(tradeAmount.toString())}</div>
        </Field>
        <Field>
          <Flex align="center">
            <Text>Kupon Penjual</Text>
            <InfoButton
              type="button"
              onClick={() =>
                openInfoModal(BondInfoType.ACCRUED_INTEREST_SELLER)
              }
            >
              <Icon
                component={InfoSvg}
                style={{
                  fontSize: 16,
                  color: '#969696',
                  marginLeft: 4,
                }}
              />
            </InfoButton>
          </Flex>
          <div>
            <Text>
              {sellerAccruedInterest > 0 && '+'}
              Rp
              {formatPrice(sellerAccruedInterest.toString())}
            </Text>
          </div>
        </Field>
        <Field>
          <Text>Bea Meterai</Text>
          <Text>
            {stampDuty > 0 && '+'}
            Rp{formatPrice(stampDuty.toString())}
          </Text>
        </Field>
      </FieldSet>
    </Accordion>
  );
}
